// Sustemia · Balance Hídrico · de dónde sale cada cosa
// Puerto directo de la hoja "10 Fuentes y criterios" de
// Sustemia_BalanceHidrico_Spec_ES_v1_2026-08-11.xlsx y de
// Sustemia_BalanceHidrico_Fuentes_ES_v1_2026-08-11.md.
//
// Alimenta la §27 del informe ("Fuentes y criterios propios"): dos tablas
// separadas, ninguna inventada.

export const CON_RESPALDO_PUBLICADO = [
  { elemento: "Ecuación del balance y trabajo en tres fases", origen: "UNEP IE/PAC – UNIDO, Audit and Reduction Manual, TR-7" },
  { elemento: "Centros de cantidad y costeo de flujos", origen: "ISO 14051, Material flow cost accounting" },
  { elemento: "Revisión del uso del agua, usos significativos", origen: "ISO 46001, Water efficiency management systems" },
  { elemento: "Clasificación de indicadores", origen: "ISO 14031, Environmental performance evaluation" },
  { elemento: "Escala de validez del dato de 1 a 5", origen: "Adaptada de AWWA / IWA, Manual M36", nota: "La escala sí; la asignación por instrumento no." },
  { elemento: "Pérdida real, aparente y consumo autorizado", origen: "AWWA / IWA, Manual M36", nota: "La cuarta categoría la agregamos nosotros." },
  { elemento: "Rangos 70–120 y 50–100 L/kg", origen: "IFC / Banco Mundial, EHS Guidelines for Textile Manufacturing, tabla 4", nota: "Imprimir siempre las dos advertencias." },
  { elemento: "Vigencia de esos rangos", origen: "JRC, BREF Textiles 2023", nota: "Reemplazó la versión CE 2003." },
  { elemento: "Evaporación de torre por diferencia", origen: "U.S. DOE / FEMP, Best Management Practice #10" },
  { elemento: "Consumo doméstico por persona", origen: "HOWARD, G.; BARTRAM, J., OMS", nota: "Publicado para uso doméstico. Acá se usa como orden de magnitud, no como valor normativo." },
];

export const CRITERIO_PROPIO_SUSTEMIA = [
  { elemento: "Grado asignado a cada instrumento", origen: "Criterio de ingeniería nuestro", nota: "La escala es de M36; la asignación no." },
  { elemento: "Aptitud de instrumento por fluido", origen: "Práctica de ingeniería", nota: "No es una norma citable." },
  { elemento: "Margen de cierre del 10 %", origen: "Umbral interno", nota: "Sin equivalente publicado, confirmado por el cliente. Alternativa: incertidumbre propagada." },
  { elemento: "Techo de estimación del 30 %", origen: "Umbral interno", nota: "Recomendación, nunca no conformidad." },
  { elemento: "Meta de calidad del dato de 4,00", origen: "Umbral interno" },
  { elemento: "Colores del semáforo", origen: "Extensión de paleta propuesta", nota: "Requiere aprobación del Design System Owner." },
  { elemento: "Categoría \"todavía no lo identificamos\"", origen: "Agregada por nosotros a las tres de M36", nota: "Evita repartos inventados." },
  { elemento: "Ausencia de rango para etiquetas y confección", origen: "No encontramos fuente publicada", nota: "Se declara la ausencia en lugar de aproximar." },
  { elemento: "Estructura de las plantillas por tipo de planta", origen: "Criterio nuestro", nota: "Traen estructura, ningún número." },
];

export const EL_MODULO_SE_NIEGA_A = [
  "Estimar el efluente como la entrada menos un porcentaje.",
  "Emitir veredicto mientras la carga está a medias.",
  "Obligar a repartir el 100 % de la diferencia.",
  "Sumar los repartos por proxy al balance.",
  "Comparar donde no hay rango publicado.",
  "Pedir un volumen sin preguntar antes de dónde sale.",
  "Dejar pasar un instrumento inadecuado con la excusa del certificado.",
];

export default { CON_RESPALDO_PUBLICADO, CRITERIO_PROPIO_SUSTEMIA, EL_MODULO_SE_NIEGA_A };
